import { SDKEnvironmentType } from '../types/SDKEnvironmentType.js';
export const getWebUrlForEnvironment = (environmentType) => {
    switch (environmentType) {
        case SDKEnvironmentType.SANDBOX:
            return 'https://tax-sandbox.getapril.com';
        case SDKEnvironmentType.PROD:
            return 'https://tax.getapril.com';
    }
};
export const getPublicApiUrlForEnvironment = (environmentType) => {
    switch (environmentType) {
        case SDKEnvironmentType.SANDBOX:
            return 'https://public-sandbox.getapril.com';
        case SDKEnvironmentType.PROD:
            return 'https://public.getapril.com';
    }
};
export const extractUserPayloadData = (userToken, onError, ignoreErrors = false) => {
    if (userToken === null) {
        return null;
    }
    const tokenParts = userToken.split('.');
    if (tokenParts.length !== 3) {
        const errorMessage = 'Provided JWT token is invalid';
        if (!ignoreErrors) {
            if (onError == null) {
                console.error(errorMessage);
            }
            else {
                onError === null || onError === void 0 ? void 0 : onError(errorMessage);
            }
        }
        return null;
    }
    const tokenPayload = tokenParts[1];
    const payloadData = JSON.parse(atob(tokenPayload.replace(/-/g, '+').replace(/_/g, '/')));
    if (!('user' in payloadData)) {
        const errorMessage = 'User JWT token is invalid, auth code is missing';
        if (!ignoreErrors) {
            if (onError == null) {
                console.error(errorMessage);
            }
            else {
                onError === null || onError === void 0 ? void 0 : onError(errorMessage);
            }
        }
        return null;
    }
    return payloadData['user'];
};
export const extractUserAuthCode = (userToken, onError) => {
    const userPayloadData = extractUserPayloadData(userToken, onError);
    if (userPayloadData === null) {
        return null;
    }
    if (!('registration_auth_code' in userPayloadData)) {
        const errorMessage = 'User JWT token is invalid, auth code is missing';
        if (onError == null) {
            console.error(errorMessage);
        }
        else {
            onError === null || onError === void 0 ? void 0 : onError(errorMessage);
        }
        return null;
    }
    return userPayloadData['registration_auth_code'];
};
